import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearchNav = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g fill="none" fillRule="evenodd"><path d="M0 0h40v40H0z" /><circle cx={18.182} cy={18.18} r={13.182} stroke="#1853a3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} /><path stroke="#1853a3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M27.727 27.725 35 34.998" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" aria-labelledby="search-nav-svg" viewBox="0 0 40 40" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgSearchNav;